import React, { useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import useAxios from "axios-hooks";
import classNames from "classnames";
import { gsap } from "gsap";

import styles from "./navigation.module.scss";

const NavigationSubmenu = ({
  path,
  isOpenedMenu,
  linkPath,
  allowScroll,
}) => {
  const [{ data, loading, error }] = useAxios({ url: path });

  const subMenuRef = useRef();

  // useLayoutEffect (() => { 
  //   // const context = gsap.context(() => {
  //   //   gsap.to("")
  //   // }) 

  //   console.log("Добавил стили");
  
  //   const animation = gsap.to(subMenuRef.current, {
  //     // rotation: "+=360",
  //     height: "auto",
  //     opacity: 1
  //   })
    
  //   return () => { // код очистки (необязательно)
  //     console.log("Убрал стили")
  //     animation.revert();
  //   }    
  // }, []);

  const subnav_list =
    data &&
    data.services.map((item, index) => {
      return (
        <Link
          to={`${linkPath}/${item.slug}`}
          className={classNames(styles.submenuItem, "header-submenu")}
          key={index}
          onClick={() => {
            allowScroll && allowScroll();
          }}
        >
          {item.title}
        </Link>
      );
    });

  return subnav_list?.length > 0 ? (
    <nav
      // ref={subMenuRef}
      className={isOpenedMenu ? styles.submenuActive : styles.submenu}
    >
      {loading && <p>Loading...</p>}
      {error && <p>Error...</p>}
      {subnav_list}

      <Link
        to="/produce"
        className={styles.submenuItem}
        onClick={() => {
          allowScroll && allowScroll();
        }}
      >
        Производственникам
      </Link>

      <Link
        to="/developers"
        className={styles.submenuItem}
        onClick={() => {
          allowScroll && allowScroll();
        }}
      >
        Девелоперам
      </Link>
    </nav>
  ) : (
    <></>
  );
};

export default NavigationSubmenu;
